import { database, ref, update } from "../../FirebaseConfig";

/**
 * Met à jour des informations spécifiques pour un vendeur
 * @param {string} id - L'identifiant du vendeur
 * @param {object} updateData - Les données à mettre à jour
 * @returns {Promise<void>}
 */
export const updateVendeurInfo = async (id, updateData) => {
    // Créer une référence à l'emplacement du vendeur
    const vendeurRef = ref(database, `vendeur/${id}`);
    
    // Ajouter le timestamp de mise à jour
    const dataToUpdate = {
        ...updateData,
        updated_at: new Date().toISOString()
    };

    try {
        // Mettre à jour les données
        await update(vendeurRef, dataToUpdate);
        console.log("Données mises à jour avec succès");
    } catch (error) {
        console.error("Erreur lors de la mise à jour des données:", error);
        throw error; // Propager l'erreur pour la gestion au niveau supérieur
    }
};

// Exemple d'utilisation:
// Pour mettre à jour une seule information
// await updateVendeurInfo("id-du-vendeur", { balanceGratuit: 100 });

// Pour mettre à jour plusieurs informations en même temps
// await updateVendeurInfo("id-du-vendeur", {
//     balanceGratuit: 100,
//     plan: true,
//     type_plan: "premium"
// });